export const GlobalConfig = {
    config: {
        apiUrl: "",
        siteID: 0,
        apiVersion: "v2",
        operatorAuthTokenId: "",
        applicationType: 0,
        domainID: "0",
        timeControl: undefined,
        initialTime: undefined,
        pageMethods: { SeamlessTokenLogin: () => { } },
        userInfo: {
            onJWTUpdated: {},
            onLogout: {},
            onLoginFailed: {},
            onNotLoggedIn: {},
            onTokenLoginReceived: {},
            onOneTimeTokenReceived: {},
            onSessionKeepAlive: {},
            loadUser: () => { },
            loginError: () => { },
            legacyWalletTokenLogin: () => { },
            logout: () => { },
            oneTimeTokenLoginFailed: () => { },
            jwtLogin: () => { },
            showSessionExpired: () => { }
        }
    }
};
//# sourceMappingURL=config.js.map